import React, {FC, useEffect} from 'react'
import {Redirect} from 'react-router-dom'
import {CreateProduct} from '../../modules/all-pages'
import {useProducts} from '../../contexts/ProductsProvider'

const CreateAccountSav: FC = () => {
    const {productsActive, productsList, demandeProducts, isLoading, refetch} = useProducts()

    const account = 'Sav'

    useEffect(() => {
        refetch()
    }, [refetch]);

    if (isLoading) {
        return null
    }

    const product = productsActive[account]
    const isActive = !!product?.activated_at
    const listItem = productsList.find((item) => item.name === account)
    const demand = demandeProducts[account]
    const treaty = demand ? parseInt(demand.trait, 10) : -1
    const description = listItem?.description || ''

    return (

        <>
            {isActive ? (
                <Redirect to="/sav" />
            ) : (
                <CreateProduct
                    name={account}
                    description={description}
                    treaty={treaty}
                />
            )}
        </>
    )
}
export {CreateAccountSav}
